module.exports = __webpack_public_path__ + "static/media/1020682_1649874556219.ab4fcb30.jpg";